import { UPDATE_RECAPTCHA_TOKEN, UPDATE_RECAPTCHA_WIDGET_ID } from './ActionTypes';
import { getUserProfile as getUserProfileSelector, getPaidMeetingsAvailableSelector
// @ts-expect-error untyped import
} from 'MeetingsLib/selectors/BookInfoSelectors';
import { showUserMessage } from './UIActions';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import Raven from 'raven-js';
// @ts-expect-error untyped import
import { getRecaptchaWidgetId } from '../../selectors/RecaptchaSelectors';
import { bookMeeting } from './BookActions';
import { jsx as _jsx } from "react/jsx-runtime";
let recaptchaSuccess = false;
let recaptchaExpired = false;
const getRecaptchaNamespace = () => window.grecaptcha.enterprise;
const updateToken = payload => ({
  type: UPDATE_RECAPTCHA_TOKEN,
  payload
});
const resetToken = () => ({
  type: UPDATE_RECAPTCHA_TOKEN,
  payload: null
});
export const updateWidgetId = payload => ({
  type: UPDATE_RECAPTCHA_WIDGET_ID,
  payload
});
export const invokeChallenge = () => (dispatch, getState) => {
  if (window.grecaptcha) {
    try {
      getRecaptchaNamespace().execute(getRecaptchaWidgetId(getState()));
    } catch (err) {
      Raven.captureMessage('Recaptcha invoke/execute failed', {
        level: 'error',
        extra: {
          message: err && err.message || 'Recaptcha invoke/execute failed',
          isRecaptchaEnterpriseValid: !!window.grecaptcha.enterprise,
          recaptchaSuccess,
          recaptchaExpired
        }
      });
    }
  }
};
export const handleChallengeSuccess = response => dispatch => {
  recaptchaSuccess = true;
  dispatch(updateToken(response));
  dispatch(bookMeeting());
};
export const handleRecaptchaExpired = () => (dispatch, getState) => {
  recaptchaExpired = true;
  const widgetId = getRecaptchaWidgetId(getState());
  dispatch(resetToken());
  if (window.grecaptcha) {
    getRecaptchaNamespace().reset(widgetId);
  }
};
export const handleRecaptchaFailed = failureResponse => (dispatch, getState) => {
  const {
    email
  } = getUserProfileSelector(getState());
  const isPaidMeeting = getPaidMeetingsAvailableSelector(getState());
  dispatch(showUserMessage({
    type: 'danger',
    content: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: "errorMessages.recaptchaFailure",
      options: {
        email
      }
    })
  }));
  Raven.captureMessage('Recaptcha challenge failed', {
    level: isPaidMeeting ? 'critical' : 'error',
    extra: {
      message: JSON.stringify(failureResponse),
      state: getState()
    },
    fingerprint: ['Recaptcha Failed']
  });
};